// extracted by mini-css-extract-plugin
export var root = "lQ8C";
export var rootCol = "CXLD";
export var rootColMobileOpened = "_9FQt";
export var rootColWithTiles = "b7Er";
export var rootLabel = "_2CAg";
export var rootLabelIcon = "_72RC";
export var rootList = "BT+n";
export var rootListItem = "YUOD";
export var rootListItemImage = "aUEF";
export var rootListItemLink = "tg7-";
export var rootListItemPicture = "Gha0";
export var rootListItemTile = "y4GO";